import React from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';

const options = {
    elements: {
        line: {
            tension: 0, // Disables bezier curves
        },
    },
    scales: {
        xAxes: [
            {
                time: {
                    unit: 'week',
                    displayFormats: {
                        'week': 'MMM',
                    },
                },
            },
        ],
        yAxes: [
            {
                ticks: {
                    min: 0,
                },
            },
        ],
    },
    legend: {
        display: false,
        position: 'bottom',
        labels: {
            fontSize: 12,
        },
    },
    tooltips: {
        enabled: true,
        mode: 'index',
        intersect: false,
        callbacks: {
            title: function (tooltipItem) {
                return `${ tooltipItem[0].xLabel }`;
            },

            label: function (tooltipItem) {
                return Number(tooltipItem.yLabel).toLocaleString('nl-NL');
            },
        },
    },
    maintainAspectRatio: true,
    responsive: true,
};

const Graph = (props) => {
    const { data, translate } = props;

    data.reverse();

    const labels = () => {
        let array = [];

        for (let i = 0; i < data.length; i++) {
            array.push(`${ translate('resources.campaigns.show.week') } ${ data[i].label.split('#')[1] }`);
        }
        return array;
    };

    const values = data.map(function (item) {
        return item.amount;
    });

    return <div
        style={ {
            width: '50%',
            minWidth: '490px',
            maxWidth: '800px',
        } }>
        <Line
            data={ {
                labels: labels(),
                datasets: [
                    {
                        backgroundColor: theme.palette.primary1Color,
                        borderCapStyle: 'butt',
                        borderColor: theme.palette.primary1Color,
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        data: values,
                        fill: false,
                        lineTension: 0.1,
                        pointBackgroundColor: theme.palette.primary1Color,
                        pointBorderColor: theme.palette.primary1Color,
                        pointBorderWidth: 2,
                        pointHitRadius: 10,
                        pointHoverBackgroundColor: theme.palette.primary1Color,
                        pointHoverBorderColor: theme.palette.primary1Color,
                        pointHoverBorderWidth: 2,
                        pointHoverRadius: 5,
                        pointRadius: 1,
                    },
                ],
            } }
            options={ options }
        />
    </div>;
};

Graph.propTypes = {
    data: PropTypes.array,
    translate: PropTypes.func.isRequired,
};

export default translate(Graph);



// WEBPACK FOOTER //
// ./src/pages/campaigns/show/Graph.js